/**
 * @file
 * Initialize Tippy.js with default settings.
 */
(function () {
  'use strict';

  // Set default props for all tooltips
  if (typeof tippy !== 'undefined') {
    tippy.setDefaultProps({
      arrow: true,
      theme: 'light',
      duration: [300, 250],
      animation: 'scale'
    });
  }
})();
